import React, { useEffect, useState } from "react";
import { covertURl } from "../../util/AwsFunction";
import UserImage from "../../assets/images/8.jpg";

const UserAvatar = ({ source, name = "User" }) => {
  const imageSource = typeof source === "string" ? source.trim() : "";
  const [resolved, setResolved] = useState({ source: "", url: UserImage });

  useEffect(() => {
    let cancelled = false;
    if (!imageSource) return;
    const load = async () => {
      try {
        const result = await covertURl(imageSource);
        if (!cancelled) setResolved({ source: imageSource, url: result?.imageURL || UserImage });
      } catch {
        if (!cancelled) setResolved({ source: imageSource, url: UserImage });
      }
    };
    load();
    return () => { cancelled = true; };
  }, [imageSource]);

  return (
    <img
      src={resolved.source === imageSource ? resolved.url : UserImage}
      alt={name || "User"}
      width="40"
      height="40"
      style={{ width: "40px", height: "40px", objectFit: "cover", flexShrink: 0 }}
      onError={() => setResolved((current) => current.source === imageSource && current.url === UserImage ? current : { source: imageSource, url: UserImage })}
    />
  );
};

export default UserAvatar;